"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPrimaryBlock = void 0;
var _1 = require(".");
var blockinfo_1 = require("../blockinfo");
var isPrimaryBlock = function (f) {
    return f.secondaryBlockSize !== undefined &&
        f.tertiaryBlockSize !== undefined &&
        !(0, _1.isFooterBlock)(f) &&
        !(0, _1.isNavBlock)(f) &&
        (f.blockType === blockinfo_1.BlockType.Primary ||
            f.blockType === blockinfo_1.BlockType.PrimaryCollection);
};
exports.isPrimaryBlock = isPrimaryBlock;
